import { useEffect } from "react";
import { useRouter } from "@/shared/lib/router/router";

/** Redirect no cliente (substitui o redirect que o getServerSideProps fazia no Next). */
export function useClientRedirect(destination: string | null): void {
  const router = useRouter();
  useEffect(() => {
    if (destination) void router.replace(destination);
  }, [destination, router]);
}

/** Normaliza um parâmetro de rota (string | string[] | undefined) para lista. */
export function toParamList(value: string | string[] | undefined): string[] {
  if (Array.isArray(value)) return value;
  return value ? [value] : [];
}
